import type { CSSProperties, MouseEventHandler, ReactNode } from 'react';
import styled from 'styled-components';

import { min } from '../../../utils/breakpoints';
import RippleLoaderLines from '../../RippleLoaderLines';
import { StyledH3 } from '../../Styled';

const InfoContainer = styled.div`
  border: 1px solid ${(props) => props.theme.colors.light};
  padding: 10px 14px;
  border-radius: 4px;

  &.secondary {
    background: ${(props) => props.theme.colors.extraLight};
    border-color: ${(props) => props.theme.colors.extraLight};
    border-radius: 4px;
  }
`;

const UnorderedList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 8px;
    font-size: 14px;

    ${min.sm} {
      font-size: 16px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const StyledAnchor = styled.a`
  font-weight: normal;
  margin-right: 1px;
`;

interface InformationPanelProps {
  title: ReactNode;
  children?: ReactNode;
  isLoading?: boolean;
  variant?: string;
  loadingLines?: number;
  editLabel?: string;
  onEdit?: MouseEventHandler<HTMLAnchorElement> | null;
  style?: CSSProperties;
}

const InformationPanel = ({
  title,
  children,
  isLoading = false,
  variant = 'primary',
  loadingLines = 4,
  editLabel = 'Edit',
  onEdit = null,
  style,
}: InformationPanelProps) => (
  <div>
    <StyledH3 className="d-flex justify-content-between">
      <span>{title}</span> {onEdit && editLabel && <StyledAnchor onClick={onEdit}>{editLabel}</StyledAnchor>}
    </StyledH3>
    <InfoContainer className={variant} style={style}>
      {isLoading ? <RippleLoaderLines lines={loadingLines} className="" /> : <UnorderedList>{children}</UnorderedList>}
    </InfoContainer>
  </div>
);

export default InformationPanel;
